//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    rowData: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      table: []
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    },
    rowData: {
      handler (val) {
        if (val) {
          this.handleTableData()
        }
      },
      deep:true
    },
  },
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  methods: {
    handleTableData () {
      let table = []
      let data = _.pick(this.rowData, 'goodsId')
      this.loading = true
      this.$axios.get('/mtea/store/admin/dealer/queryByGoods', { params: data }).then(res => {
        this.table = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit (row) {
      this.$emit('submit', row)
      this.$emit('update:visible', false)
    },
    handleOpen () {
      this.handleTableData()
    }
  }
}
